import { hostFactory as hostInstance } from "../factory";

const getTierById = id => hostInstance.get(`/api/tiers/${id}`);

const getTiers = () => hostInstance.get("/api/tiers");

const deleteTier = id => hostInstance.delete(`/api/tiers/${id}`);

export { getTierById, deleteTier };

export default getTiers;
